/** @format */

import { Link, useLocation } from 'react-router-dom';

import { useAccess } from '../../Shared/hooks/useAccess';

const ACTIVE_BG = 'rgb(102 204 163)';
const DEFAULT_BG = 'rgb(177 218 226)';

const Sidebar = () => {
  const { pathname } = useLocation();
  const {
    canManageUsers,
    canManageRoles,
    canManagePaymentSettings,
    canManageBaseData,
    canListClubs,
    canManageMatches,
    canViewFinancialReports,
    canViewMatchReports,
    canManageTickets,
  } = useAccess();

  const openSubMenu = (id) => {
    const subMenu = document.getElementById(id);
    const subMenuTags = document.getElementsByClassName('sub-menu');

    if (!subMenu) {
      return;
    }

    if (subMenu.classList.contains('d-none')) {
      Array.from(subMenuTags).forEach((el) => {
        el.classList.remove('d-flex');
        el.classList.add('d-none');
      });
      subMenu.classList.remove('d-none');
      subMenu.classList.add('d-flex');
    } else {
      subMenu.classList.remove('d-flex');
      subMenu.classList.add('d-none');
    }
  };

  const isMenuActive = (menu) => {
    const subPaths =
      menu.sub_paths?.map((sub) => sub.path).filter(Boolean) ?? [];

    return menu.main_path === pathname || subPaths.includes(pathname);
  };

  const menus = [
    {
      id: 1,
      main_path: '/panel',
      title: 'داشبورد',
      access: true,
      sub_paths: [],
    },
    {
      id: 2,
      main_path: '#',
      title: 'ادمین',
      access: canManageUsers() || canManageRoles() || canManagePaymentSettings(),
      sub_paths: [
        {
          id: 1,
          path: '/panel/admin/users',
          title: 'کاربران',
          access: canManageUsers(),
        },
        {
          id: 2,
          path: '/panel/admin/roles',
          title: 'نقش ها',
          access: canManageRoles(),
        },
        {
          id: 3,
          path: '/panel/admin/payment-settings',
          title: 'تنظیمات درگاه',
          access: canManagePaymentSettings(),
        },
      ],
    },
    {
      id: 3,
      main_path: '#',
      title: 'پروفایل',
      access: true,
      sub_paths: [
        {
          id: 1,
          path: '/panel/profile',
          title: 'اطلاعات کاربری',
          access: true,
        },
        {
          id: 2,
          path: '/panel/tickets',
          title: 'تیکت‌های من',
          access: true,
        },
        {
          id: 3,
          path: '/panel/profile/my-payments',
          title: 'ریزتراکنش‌های من',
          access: true,
        },
      ],
    },
    {
      id: 9,
      main_path: '#',
      title: 'پشتیبانی',
      access: canManageTickets(),
      sub_paths: [
        {
          id: 1,
          path: '/panel/tickets/inbox',
          title: 'صندوق ورودی',
          access: canManageTickets(),
        },
      ],
    },
    {
      id: 4,
      main_path: '#',
      title: 'اطلاعات پایه مسابقات',
      access: canManageBaseData(),
      sub_paths: [
        {
          id: 1,
          path: '/panel/base-define/post',
          title: 'ساختار تیم',
          access: canManageBaseData(),
        },
        {
          id: 2,
          path: '/panel/base-define/age',
          title: 'رده سنی',
          access: canManageBaseData(),
        },
        {
          id: 3,
          path: '/panel/base-define/match-level',
          title: 'مراحل مسابقات',
          access: canManageBaseData(),
        },
        {
          id: 4,
          path: '/panel/base-define/match-style',
          title: 'سبک های مسابقات',
          access: canManageBaseData(),
        },
      ],
    },
    {
      id: 8,
      main_path: '#',
      title: 'باشگاه',
      access: true,
      sub_paths: [
        {
          id: 1,
          path: '/panel/clubs/my',
          title: 'باشگاه‌های من',
          access: true,
        },
        {
          id: 2,
          path: '/panel/clubs',
          title: 'لیست باشگاه‌ها',
          access: canListClubs(),
        },
      ],
    },
    {
      id: 5,
      main_path: '#',
      title: 'مسابقات',
      access: true,
      sub_paths: [
        {
          id: 1,
          path: '/panel/matches/lists',
          title: 'لیست مسابقات',
          access: canManageMatches(),
        },
        {
          id: 2,
          path: '/panel/profile/match-registered',
          title: 'مسابقات من',
          access: true,
        },
      ],
    },
    {
      id: 6,
      main_path: '#',
      title: 'مالی',
      access: true,
      sub_paths: [
        {
          id: 1,
          path: '/panel/matches/financial-management/increase-wallet',
          title: 'افزایش کیف پول',
          access: true,
        },
        {
          id: 2,
          path: '/panel/matches/financial-management/wallet-history',
          title: 'تاریخچه کیف پول',
          access: true,
        },
      ],
    },
    {
      id: 7,
      main_path: '#',
      title: 'گزارشات',
      access: canViewMatchReports() || canViewFinancialReports(),
      sub_paths: [
        {
          id: 1,
          path: '/panel/reports/match-lists',
          title: 'مسابقات',
          access: canViewMatchReports(),
        },
        {
          id: 2,
          path: '/panel/reports/all-payments',
          title: 'تراکنش ها',
          access: canViewFinancialReports(),
        },
      ],
    },
  ];

  return (
    <aside className='w-100 rounded-1 overflow-hidden mt-1 p-2 py-2 bg-sky-light shadow-sm rounded-1'>
      <div className='sidebar-header text-left'>
        <h1 className='text-dark f-14 font-weight-bold border-bottom border-secondary p-3 text-center'>
          ادمین
        </h1>
      </div>
      <ul className='d-flex flex-column nav m-0'>
        {menus.map(
          (menu) =>
            menu.access && (
              <li
                key={menu.id}
                className='p-2 my-1 rounded'
                onClick={() => openSubMenu(`sub-menu-${menu.id}`)}
                style={{
                  background: isMenuActive(menu) ? ACTIVE_BG : DEFAULT_BG,
                }}
              >
                <Link
                  to={menu.main_path}
                  className='text-dark f-13 d-flex flex-row justify-content-between'
                  onClick={(e) => {
                    if (menu.main_path === '#') {
                      e.preventDefault();
                    }
                  }}
                >
                  + {menu.title}
                  {isMenuActive(menu) ? (
                    <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                      .
                    </span>
                  ) : null}
                </Link>
                <ul
                  id={`sub-menu-${menu.id}`}
                  className={`${
                    isMenuActive(menu) ? 'd-flex' : 'd-none'
                  } flex-column nav sub-menu`}
                >
                  {menu.sub_paths.map(
                    (sub) =>
                      sub.access && (
                        <li
                          key={`${menu.id}-${sub.id}`}
                          className='my-1 rounded p-2 mx-2'
                        >
                          <Link
                            to={sub.path}
                            className='text-dark d-flex flex-row justify-content-start f-13'
                          >
                            - {sub.title}
                          </Link>
                        </li>
                      ),
                  )}
                </ul>
              </li>
            ),
        )}
      </ul>
    </aside>
  );
};

export default Sidebar;
